module.exports = __webpack_public_path__ + "static/media/Snapchat.ba4201f0.svg";